import { render, staticRenderFns } from "./gatewayNode.vue?vue&type=template&id=1f04b8f2&scoped=true&"
import script from "./gatewayNode.vue?vue&type=script&lang=js&"
export * from "./gatewayNode.vue?vue&type=script&lang=js&"
import style0 from "./gatewayNode.vue?vue&type=style&index=0&id=1f04b8f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04b8f2",
  null
  
)

export default component.exports